import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AddTemplateComponent } from '../add-template/add-template.component';
import { RolesService } from '../../roles/roles.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-preview-smm-template',
  templateUrl: './preview-smm-template.component.html',
  styleUrls: ['./preview-smm-template.component.scss']
})
export class PreviewSmmTemplateComponent {
  template: any;
  selectedTabIndex = 0;
  isAdmin: boolean = false

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<PreviewSmmTemplateComponent>,
    private dialog: MatDialog,
    private rolesService: RolesService,
    private snackBar: MatSnackBar
  ) {
    // Normalize template fields to avoid undefined errors
    this.template = {
      ...data.template,
      images: data.template?.images || [],
      tags: data.template?.tags || [],
      goals: data.template?.socialGoals || [],
      bestChannels: data.template?.platform || [],
      platform: data.template?.platform || [],
      framework: Array.isArray(data.template?.framework)
        ? data.template.framework
        : data.template?.framework ? [data.template.framework] : [],
      exampleText: data.template?.exampleText || '',
      templateText: data.template?.rawTemplate || data.template?.templateText || '',
      description: data.template?.description || '',
      specifications: data.template?.specifications || '',
      callToAction: data.template?.callToAction || ''
    };
    this.isAdmin = localStorage.getItem('staffType') === 'ADMIN'
  }

  /** Close preview popup */
  close(): void {
    this.dialogRef.close();
  }

  /** Switch from preview -> edit */
  useTemplate() {
    const templateForEdit = {
      ...this.template,
      goals: this.template.goals?.map((g: any) => ({ id: g.id, name: g.name })) || [],
      bestChannels: [...(this.template.bestChannels || [])],
      images: [...(this.template.images || [])],   // ✅ fixed (was imageUrl)
      framework: this.template.framework,
      exampleText: this.template.exampleText,
      templateText: this.template.templateText,
      description: this.template.description,
      specifications: this.template.specifications,
      callToAction: this.template.callToAction,
      hookStrategy: this.template.hookStrategy,
      selectedIndustry: this.template.selectedIndustry,
      selectedSubIndustry: this.template.selectedSubIndustry,
      category: this.template.category
    };

    this.dialogRef.close();

    this.dialog.open(AddTemplateComponent, {
      width: '100vw',
      height: '100vh',   // ✅ fixed
      panelClass: 'full-screen-dialog',
      data: { template: templateForEdit, isEditMode: true }
    });
  }

  updateTemplateStatus(status: string){
    this.data.template.templateStatus === status
    let payload={
      ...this.data.template,
      templateStatus: status,
    }
    const { createdAt, updatedAt, createdBy, lastUpdatedBy, ...cleanPayload } = payload;
    this.rolesService.createTemplate(cleanPayload).subscribe((res: any) =>{
      if(status === 'APPROVED'){
        this.snackBar.open('Template Accepted Successfully', 'Close',{
          duration: 1500
        })
      }
      if(status === 'REJECTED'){
        this.snackBar.open('Template Rejected Successfully', 'Close',{
          duration: 1500
        })
      }
      this.dialogRef.close()
    })
  }
}


